module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('van-popup', {
    style: ({
      height: '70%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClonse
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输入手机号/用户名称搜索"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('van-radio-group', {
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('van-cell-group', _vm._l((_vm.businessUserList), function(item, index) {
    return (index < _vm.limit) ? _c('van-cell', {
      key: index,
      attrs: {
        "is-link": "",
        "clickable": ""
      },
      on: {
        "click": function($event) {
          _vm.radio = item
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('img', {
      staticClass: "cell-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "van-cell__label"
    }, [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('van-radio', {
      attrs: {
        "slot": "right-icon",
        "name": item,
        "checked-color": "#FD2840"
      },
      slot: "right-icon"
    })], 2) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "createbtn"
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    },
    on: {
      "click": _vm.UserAdd
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c4ef532","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/UserPicker.vue
// module id = 2511
// module chunks = 0